import { getDocuments, addDocument as addDocumentApi } from "api/document";
import logoutCheck from "assets/scripts/utils/logoutCheck";
import mapBackendErrors from "assets/scripts/utils/mapBackendErrors";
import { fieldErrorsBackToFront } from "assets/scripts/domain/misc/dataConversion";
export const DOCUMENT_ACTIONS = {
    LOAD_DOCUMENTS_STARTED: "load-documents-started",
    LOAD_DOCUMENTS_FAILED: "load-documents-failed",
    LOAD_DOCUMENTS_SUCCEEDED: "load-documents-succeeded",
    ADD_MODAL_CHANGE: "add-modal-change",
    ADD_DOCUMENT_STARTED: "add-document-started",
    ADD_DOCUMENT_FAILED: "add-document-failed",
    ADD_DOCUMENT_SUCCEEDED_TRUE: "add-document-succeeded-true",
    ADD_DOCUMENT_SUCCEEDED_FALSE: "add-document-succeeded-false"
};
export const loadDocuments = () => async (dispatch) => {
    dispatch({
        type: DOCUMENT_ACTIONS.LOAD_DOCUMENTS_STARTED
    });
    try {
        const { data } = await getDocuments();
        if (!data.success) {
            throw new Error("Unexpected response");
        }
        dispatch({
            type: DOCUMENT_ACTIONS.LOAD_DOCUMENTS_SUCCEEDED,
            payload: data.data
        });
    }
    catch (error) {
        dispatch({
            type: DOCUMENT_ACTIONS.LOAD_DOCUMENTS_FAILED,
            payload: error
        });
        logoutCheck(error, dispatch);
    }
};
export const addModalChange = (open) => ({
    type: DOCUMENT_ACTIONS.ADD_MODAL_CHANGE,
    payload: open
});
export const addDocument = (document) => async (dispatch) => {
    dispatch({
        type: DOCUMENT_ACTIONS.ADD_DOCUMENT_STARTED
    });
    try {
        const { data } = await addDocumentApi(document);
        if (data.success) {
            dispatch({
                type: DOCUMENT_ACTIONS.ADD_DOCUMENT_SUCCEEDED_TRUE,
                payload: data.data
            });
        }
        else {
            dispatch({
                type: DOCUMENT_ACTIONS.ADD_DOCUMENT_SUCCEEDED_FALSE,
                payload: mapBackendErrors(fieldErrorsBackToFront(data.errors))
            });
        }
    }
    catch (error) {
        dispatch({
            type: DOCUMENT_ACTIONS.ADD_DOCUMENT_FAILED,
            payload: error
        });
        logoutCheck(error, dispatch);
    }
};



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/document/documentActions.ts